import type { SVGProps } from 'react';

export const Envelope = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'envelope'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0" />
      <g transform="translate(0.000000, 4.000000)">
        <g fill={props.fill}>
          <path d="M29.1764706,1.42108547e-14 C30.7331765,1.42108547e-14 32,1.26682353 32,2.82352941 L32,21.6470588 C32,23.2037647 30.7331765,24.4705882 29.1764706,24.4705882 L2.82352941,24.4705882 C1.26682353,24.4705882 0,23.2037647 0,21.6470588 L0,2.82352941 C0,1.26682353 1.26682353,1.42108547e-14 2.82352941,1.42108547e-14 L29.1764706,1.42108547e-14 Z M21.6806588,13.4397176 L19.9470118,15.1733647 C18.8928941,16.2274824 17.4905412,16.8081882 15.9997176,16.8081882 C14.5088941,16.8081882 13.1074824,16.2274824 12.0533647,15.1733647 L12.0533647,15.1733647 L10.3197176,13.4397176 L1.90523961,21.8536506 C1.99976307,22.2733533 2.37588013,22.5882353 2.82352941,22.5882353 L29.1764706,22.5882353 C29.6241199,22.5882353 30.0002369,22.2733533 30.0947604,21.8536506 L21.6806588,13.4397176 Z M1.882,5.002 L1.882,19.4 L9.08112941,12.2020706 L1.882,5.002 Z M30.117,5.002 L22.9183059,12.2020706 L30.117,19.4 L30.117,5.002 Z M29.1764706,1.88235294 L2.82352941,1.88235294 C2.39500412,1.88235294 2.03202975,2.17090555 1.91887941,2.56373766 L13.2910118,13.9357176 C14.7846588,15.4293647 17.2147765,15.4293647 18.7084235,13.9357176 L18.7084235,13.9357176 L30.0814077,2.56473661 C29.9685854,2.17139483 29.605359,1.88235294 29.1764706,1.88235294 Z" />
        </g>
        <rect height="32" width="32" x="0" y="-4" />
      </g>
    </g>
  </svg>
);
